import { Component, Input, OnInit } from '@angular/core';
import {OptionsNgxOwCarouselService} from 'dmmp-services';

@Component({
  selector: 'dmmp-gallery',
  templateUrl: './basic-page-gallery.component.html'
})
export class BasicPageGalleryComponent implements OnInit {
  @Input() data
  @Input() module
  @Input() identifier
  configCarrousel
  constructor(private options : OptionsNgxOwCarouselService) { }

  ngOnInit(): void {
    this.configCarrousel = this.options.configurationBenefits(this.module)
  }

}
